
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.363 41.506H17.246a2.884 2.884 0 012.7-1.879h5.717c1.236 0 2.293.783 2.7 1.88zm4.246-19.247h2l-.011.52a11.715 11.715 0 01-3.486 7.867 11.717 11.717 0 01-7.308 3.37v3.611h1.859a4.885 4.885 0 014.879 4.88v1H15.067v-1a4.885 4.885 0 014.879-4.88h1.858v-3.616c-5.857-.499-10.526-5.31-10.793-11.218H11v-.534h2c0 5.354 4.356 9.753 9.711 9.804 2.665-.013 5.121-.983 6.994-2.838a9.736 9.736 0 002.904-6.966zm-16.67-1.346v.24c0 4.391 3.054 7.995 6.807 8.032 1.665-.004 3.235-.658 4.488-1.898 1.548-1.533 2.435-3.769 2.435-6.134v-.24h-4.113v-2h4.113v-1.806h-4.113v-2h4.113v-1.806h-4.113v-2h4.08c-.165-2.09-1.016-4.03-2.405-5.403-1.238-1.224-2.808-1.897-4.426-1.897l-.064.001c-3.538.038-6.452 3.25-6.77 7.3h4.36v2H15.94v1.805h4.392v2H15.94v1.806h4.392v2H15.94zm6.787 10.272c-4.846-.048-8.787-4.549-8.787-10.032v-9.119c0-5.479 3.938-9.979 8.78-10.032 2.167-.052 4.282.855 5.918 2.474 1.927 1.906 3.032 4.661 3.032 7.558v9.12c0 2.894-1.103 5.648-3.028 7.553-1.616 1.6-3.685 2.478-5.836 2.478h-.079z"}})])
          )
        }
      }
    